import React, { ComponentProps, FC } from "react";
import { cls } from "cls";

interface ListItemProps extends ComponentProps<"li"> {
  itemIndex?: number;
}

const ListItem: FC<ListItemProps> = ({
  className,
  children,
  itemIndex,
  ...rest
}) => (
  <li
    className={cls(
      "group flex-col flex-shrink-0 list-none relative transform origin-center scale-100 scroll-snap-align-start",
      "active:top-0.5",
      itemIndex === 0 ? "pl-1" : "",
      className,
    )}
    data-testid="Carousel Item"
    {...rest}
  >
    {children}
  </li>
);

export default ListItem;
